//**************************************************************
import {  Component, 
          ViewEncapsulation, 
          ChangeDetectorRef,
          ViewChild, 
          LOCALE_ID,
          OnInit, Output, EventEmitter,
          Inject }                                              from '@angular/core';

import { trigger, state, style, transition, animate }           from '@angular/animations';

import { formatDate,  
         FormatWidth,
         getLocaleDateFormat  }                                 from '@angular/common';
//**************************************************************
// Router
import { Router, ActivatedRoute }       from '@angular/router';

import { Observable, Subscription }     from 'rxjs';
//**************************************************************
// Firestore 
import { firestorecontrol }             from "../../appfirestore/app.firestore";
import { Timestamp }                    from "@firebase/firestore";
//**************************************************************
// Field Definitions
import { participantfield, Change }     from '../../appfirestore/app.fields';
import { whoseguestinit, 
         participantcommonfield }       from '../../appfirestore/app.fields';
//**************************************************************         
// Devextreme
import  {
          DxDataGridComponent,
          DxNumberBoxComponent,
          DxTextAreaComponent, 
          DxDateBoxComponent,
          DxFormComponent
        } from 'devextreme-angular';

import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';
//**************************************************************        
// Functions
import { appfunctions  }                from '../../functions/app.functions';
//**************************************************************
@Component(
            {
              selector: 'app-comeventprofiles',
              templateUrl: './comeventprofiles.component.html',
              styleUrls: ['./comeventprofiles.component.scss'],
              encapsulation: ViewEncapsulation.None,
              animations: [
                            trigger('flipguest', [
                                                    state('active', style(
                                                                            {
                                                                              transform: 'rotateY(179deg)'
                                                                            }
                                                                          )),
                                                    state('inactive', style
                                                                          ( {
                                                                              transform: 'rotateY(0)'
                                                                            }
                                                                          )
                                                          ),
                                                    transition('active => inactive', animate('500ms ease-out')),
                                                    transition('inactive => active', animate('500ms ease-in'))
                                                ]
                                    ),

                              trigger('flipbudget', [
                                                      state ('active', style(
                                                                              {
                                                                                transform: 'rotateY(179deg)'
                                                                              }
                                                                            )
                                                            ),
                                                      state('inactive', style(
                                                                                {
                                                                                  transform: 'rotateY(0)'
                                                                                }
                                                                              )
                                                            ),
                                                      transition('active => inactive', animate('500ms ease-out')),
                                                      transition('inactive => active', animate('500ms ease-in'))
                                                    ]
                                      ),

                                  trigger('flipevent', [
                                                          state ('active', style(
                                                                                  {
                                                                                    transform: 'rotateY(179deg)'
                                                                                  }
                                                                                )
                                                                ),
                                                          state('inactive', style(
                                                                                    {
                                                                                      transform: 'rotateY(0)'
                                                                                    }
                                                                                  )
                                                                ),
                                                          transition('active => inactive', animate('500ms ease-out')),
                                                          transition('inactive => active', animate('500ms ease-in'))
                                                        ]
                                            ),

                                    trigger('flipeventlocation', [
                                                                    state ('active', style(
                                                                                            {
                                                                                              transform: 'rotateY(179deg)'
                                                                                            }
                                                                                          )
                                                                          ),
                                                                    state('inactive', style(
                                                                                              {
                                                                                                transform: 'rotateY(0)'
                                                                                              }
                                                                                            )
                                                                          ),
                                                                    transition('active => inactive', animate('500ms ease-out')),
                                                                    transition('inactive => active', animate('500ms ease-in'))
                                                                  ]
                                            ),


                                      trigger('flipeventdate',      [
                                                                      state ('active', style(
                                                                                              {
                                                                                                transform: 'rotateY(179deg)'
                                                                                              }
                                                                                            )
                                                                            ),
                                                                      state('inactive', style(
                                                                                                {
                                                                                                  transform: 'rotateY(0)'
                                                                                                }
                                                                                              )
                                                                            ),
                                                                      transition('active => inactive', animate('500ms ease-out')),
                                                                      transition('inactive => active', animate('500ms ease-in'))
                                                                    ]
                                                )
                      ]
            }
            
          )
//**************************************************************
export class ComeventprofilesComponent implements OnInit
  {
    //*******************************************************
    // Declare an event emitter
    @Output() childEmitter = new EventEmitter();
    //*******************************************************
    @ViewChild('grideventparticipants') dataGrid: DxDataGridComponent;
    @ViewChild('guestno') inputguestno: DxNumberBoxComponent;
    @ViewChild('budget') inputbudgetno: DxNumberBoxComponent;
    @ViewChild('eventype') inputevent: DxTextAreaComponent;
    @ViewChild('eventlocation') inputeventlocation: DxTextAreaComponent;
    @ViewChild('eventdate') inputeventdate: DxDateBoxComponent;
    @ViewChild('eventrsvpdate') inputrsvpeventdate: DxDateBoxComponent;
    //*******************************************************
    @ViewChild('targetGroupGuestNo', {static: false}) validationGuestNo: DxValidationGroupComponent
    @ViewChild('targetGroupBudget', {static: false}) validationBudget: DxValidationGroupComponent
    @ViewChild('targetGroupEventName', {static: false}) validationEventName: DxValidationGroupComponent
    @ViewChild('targetGroupEventLocation', {static: false}) validationEventLocation: DxValidationGroupComponent
    @ViewChild('targetGroupEventDate', {static: false}) validationEventDate: DxValidationGroupComponent

    @ViewChild('formparticipant') formparticipant: DxFormComponent;
    //*******************************************************
    // Format for date, currency & time
    localedateformat: string = "";
    //*******************************************************
    // eventid
    eventid: string = '';

    // firestore collection paths
    pathorganiserprofile: string        = "/eventparticipant/list" 
    pathcommonprofile: string           = "/eventparticipantcommon/commonprofile" 
    pathstatTotalinviteeprofile: string = "/eventdashboard/invitee" 
    pathstatTotalbudgetprofile: string  = "/eventdashboard/finance" 

    // eventparticipant
    subscriptioneventparticipant: Subscription;
    subscriptioneventparticipantlist: participantfield[];

    // eventparticipantcommon
    subscriptioneventparticipantcommon: Subscription;
    subscriptioneventparticipantlistcommon: participantcommonfield[];

    // Scroll View
    scrollByContent = true;
    scrollByThumb = true;
    scrollbarMode: string;
    pullDown = false;

    // Screen width & Height
    formheight: number = 0;

    // Collaborator Form
    formparticipantData: Array<participantfield>
    formparticipantDataVarible: any;
    rowparticipantdata: any;

    // Row Selected
    rowselect: boolean = false;
    inputstatus: boolean = false;
    statusvaluechange: boolean = false;

    rowParticipantSelect: boolean = false; 
    focusedParticipantRowKey: number = 0;

    popuptitle: string;
    popupparticipantVisible: boolean = false;

    // Flip State Guest Invite - Default
    // inactive = start card
    // active   = input card

    fliptext = "";

    // Flip Guest
    flipguest: string = 'inactive';
   
    // Flip State Budget - Default
    flipbudget: string = 'inactive';
 
    // Flip Event Type - Default
    flipevent: string = 'inactive';
   
    // Flip Event Location - Default
    flipeventlocation: string = 'inactive';
  
    // Flip Event Date - Default
    flipeventdate: string = 'inactive';

    // Organiser Data when selected
    selorgid:               string;

    selnoguestinvite:       number = 0;
    prevselnoguestinvite:   number = 0;

    selbudgetamount:        number = 0;
    prevselbudgetamount:    number = 0;

    seleventtype:           string = 'TBC';
    prevseleventtype:       string = 'TBC';

    seleventlocation:       string = 'TBC';
    prevseleventlocation:   string = 'TBC';

    seleventdate:           Date | string | number  =  new Date();
    prevseleventdate:       Date | string | number;
    seleventdatestring:     string = 'TBC';
    preveventdatestring:    string = 'TBC';
  
    seleventrsvpdate:             Date | string | number  =  new Date();
    prevseleventrsvpdate:         Date | string | number;
    seleventrsvpdatestring:       string = 'TBC';
    preveventrsvpdatestring:      string = 'TBC';

    previnvitevalue: any;
    currinvitevalue: any;
    
    prevbudgetvalue: any;
    currbudgetvalue: any;
    
    // Undo Button - Disable Flag
    datachange:             boolean = true;

    // Locate Date format
    selgetLocaleDateFormat : string;
    content: string;

    // Button
    selButton: number = 0;
    buttondisable: boolean = true;

    // Toast Switches
    toastFileMessage: string = '';
    toasttypeerror: string = 'error';
    toastdisplaytime: number = 3000
    toastVisible: boolean = false;
    toastwidth: string = '240';
    toastposX: number = 180;
    toastposY: number = 20;


    // Button Settings for Save and/or Undo for Datagrid PopUp Form
    //saveButtonOptions: any = {
    //                            text: "Save",
    //                            stylingMode: "contained",
    //                            type: "success",
    //                            onClick: (e: any) => 
    //                              {
    //                                this.dataGrid.instance.saveEditData();
    //                              }
    //                          }


    //cancelButtonOptions: any = {
    //                              text: "Cancel",
    //                              type: "danger",
    //                              stylingMode: "text",
    //                               onClick: (e: any) => 
    //                                {
    //                                  this.dataGrid.instance.cancelEditData();
    //                               }
    //                            }

   
    //*******************************************************
    constructor (
                  private firestoredata: firestorecontrol, 
                  private routernavigate: Router,
                  private _Activatedroute:ActivatedRoute,
                  private cdRef : ChangeDetectorRef,
                  private appfunction: appfunctions,

                  @Inject(LOCALE_ID) public locale: string
                ) 
      { 
        this.onClick = this.onClick.bind(this);

        this.saveParticipantClick   = this.saveParticipantClick.bind(this);
        this.cancelParticipantClick = this.cancelParticipantClick.bind( this); 
      }
    //*******************************************************
    ngOnInit(): void 
      {
        //---------------------------------------------------------------------------------------------
        // EventId
        this.eventid     = String(this._Activatedroute.snapshot.paramMap.get("eventid"))
        // Form Height
        this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
        //---------------------------------------------------------------------------------------------
        // Establish Connection to event -> eventparticipant
        this.firestoredata.loadeventparticipant( this.eventid );

        this.subscriptioneventparticipant = this.firestoredata.geteventparticipant().subscribe
          ( items => 
            { 
              this.subscriptioneventparticipantlist = items;
              // console.log( this.subscriptioneventparticipantlist )
            }
          )
        //---------------------------------------------------------------------------------------------
        // Temporary Measure    
        this.locale_setdatecurrencytime( this.locale );
        //---------------------------------------------------------------------------------------------
      }
    //*******************************************************
    ngAfterViewChecked()
      {
        this.cdRef.detectChanges();
      }
    //*******************************************************
    ngOnDestroy() 
      {
        //---------------------------------------------------------------------------------------------
        this.subscriptioneventparticipant.unsubscribe()
        //---------------------------------------------------------------------------------------------
        if (typeof this.subscriptioneventparticipantcommon != 'undefined'  )
          {
            this.subscriptioneventparticipantcommon.unsubscribe()
          }
        //--------------------------------------------------------------------------------------------- 
      }
    //*******************************************************
    datagrideditorPreparing( event: any )
    {
      if (  event.rowType == "data"  && event.column.command =="edit" )
        {
        
          var $links = event.cellElement.find(".dx-link");
          // Remove Delete and Edit Icon
         // $links.filter(".dx-link-delete").remove();
          $links.filter(".dx-link-edit").remove();
        }
      }
  //*******************************************************
  onrowparticipantclick( event: any )
    { 
      this.rowParticipantSelect         = true;             // Indicate that Datagrid - Row has been selected
    
      this.buttondisable                = false;            // Enable Collaborator Edit button

      // Capture Select Row Data Id
      this.focusedParticipantRowKey     = event.data.id;    // Register Data Row - id

      // Store data to Variable
      this.participantdataprofile( 10, event )               // Store Data Row Data

      // Flip Boards
      this.eventprofiles( event )
    }
  //*******************************************************
  onrowparticipantchange( event: any )
    {
        this.rowParticipantSelect                 = true;                               // Indicate that Datagrid - Row has been selected
        
        this.buttondisable                        = true;                              // Enable Participant Edit button
        
        this.dataGrid.instance.clearSelection();      
          
        // Capture Select Row Data Id
        this.focusedParticipantRowKey             = event.row.data.id;                  // Register Data Row - id
      
        // Register data
        this.participantdataprofile( 20, event )                                        // Store Data Row Data

        // Register Flip Participant Details
        this.onrowchange( event )
    }
  //*******************************************************
  participantdataprofile( settype: number,  seldata: any)
    {
      switch ( settype )
        {
          // Row Click
          case 10:
            {

              this.formparticipantData      = seldata.data;
              this.rowparticipantdata       = seldata.data;   // Collaborator Data before any edit changes
            // console.log( seldata.data  )
              break;
            }

          // Row Change
          case 20:
            {
              this.formparticipantData      = seldata.row.data;
              this.rowparticipantdata       = seldata.row.data;  // Collaborator Data before any edit changes
              break; 
            }

        }

    }
  //*******************************************************
  // Save Collaborator Detail 
  saveParticipantClick()
   {
     
     let validresult = this.formparticipant.instance.validate();
  
     if ( validresult.isValid )
       {
     
        this.formparticipantDataVarible               = this.formparticipantData;

        // Set for any possible changes
        switch (  this.selButton )
          {
            case 10: // Add Participant
              {
                this.formparticipantDataVarible.noguestinvite = 0;
                this.formparticipantDataVarible.budgetamount  = 0;
                
                // Update Firestore
                this.firestoredata.crudinserteventparticipant( this.eventid, this.formparticipantDataVarible );
                // Reset Flip Cards to force a participant row selection after a add
                this.rowselect = false;
                break;
              }

            case 20: // Edit Participant
              {
                this.formparticipantDataVarible.noguestinvite = this.selnoguestinvite;
                this.formparticipantDataVarible.budgetamount  = this.selbudgetamount;

                // Update Firestore
                this.firestoredata.crudupdateeventparticipant( this.eventid, this.formparticipantDataVarible )
                break;
              }

          }
        //---------------------------------------------------------------------------------------------
        // Focos Row when inserted
        this.dataGrid.instance.clearSelection();
        this.dataGrid.instance.option("focusedRowKey",  -1 );

        // Focus Row when inserted
        setTimeout(() => {
                            this.dataGrid.instance.option("focusedRowKey",  this.formparticipantDataVarible.id );
                          }, 100
                    );
        //---------------------------------------------------------------------------------------------
       if ( this.selButton == 20 ) // Edit Button
         {
            this.buttondisable = true;
         }
        //---------------------------------------------------------------------------------------------
        this.selButton == 0;
        this.popupparticipantVisible = false;
        //---------------------------------------------------------------------------------------------
       }
    
   }
  //*******************************************************
  cancelParticipantClick()
    {

      if ( this.statusvaluechange ) // If there is any changes but cancel update with previous data by trigger refresh
        {
          //---------------------------------------------------------------------------------------------
          if ( this.selButton == 20 ) // Edit Option
            {
              
              // Update Firestore 
              this.firestoredata.commitbatchupdate( 
                                                    this.pathorganiserprofile, 
                                                    this.eventid,
                                                    this.focusedParticipantRowKey.toString(),
                                                    'triggerrefresh', 
                                                    this.appfunction.createuniqueid(3)
                                                  );  

              // Focus Row when cancel
              this.dataGrid.instance.clearSelection();
              this.dataGrid.instance.option("focusedRowKey",  -1 );
              setTimeout(() => {
                                 this.dataGrid.instance.option("focusedRowKey",  this.focusedParticipantRowKey  );
                                }, 100
                        );

              this.dataGrid.instance.focus();
            }
          //--------------------------------------------------------------------------------------------- 
      }
      //---------------------------------------------------------------------------------------------
     // if ( this.selButton == 20 )
     //   {
          this.buttondisable = true;
      //  }
      //---------------------------------------------------------------------------------------------
      this.selButton                = 0  // Reset Status
      this.popupparticipantVisible  = false;
    }
  //---------------------------------------------------------------------------------------------
  formParticipantDatafldchange( event: any )
    {
      // Formdata has changed
     
      if ( this.selButton == 10 || this.selButton == 20 )
        {
          this.statusvaluechange = true;
        }
    }
  //*******************************************************
  participantform( event: any, seloption: number)
    {
      var status: boolean
      //---------------------------------------------------------------------------------------------
      this.selButton          = seloption;    // Which Button Add=10 or Edit=20 
      this.statusvaluechange  = false;        // Detect any changes it formdata fields
      //---------------------------------------------------------------------------------------------
      // Determine whether a ROW is selected when its not a ADD option
      if ( this.selButton  != 10 ) // Edit Mode
        {
        
          if ( this.rowParticipantSelect ) 
            {
              status             = true;
            }
          else
            {
              status             = false; 
            }
        }
      //---------------------------------------------------------------------------------------------
      switch ( seloption )
      {
        //---------------------------------------------------------------------------------------------
        // Add Participant
        case 10:
            {
              //---------------------------------------------------------------------------------------------
              // Set Inputs to default values
              this.formparticipantData                          = [];
              let participantid                                 = this.appfunction.createuniqueid(6) 
              //---------------------------------------------------------------------------------------------
              // Assign Values
              this.formparticipantDataVarible                  = this.formparticipantData;

              this.formparticipantDataVarible.id               = participantid;
              this.formparticipantDataVarible.firstname        = '';
              this.formparticipantDataVarible.lastname         = '';
              this.formparticipantDataVarible.identity         = '';
              this.formparticipantDataVarible.noguestinvite    = 0;
              this.formparticipantDataVarible.budgetamount     = 0;
              //---------------------------------------------------------------------------------------------
              // Set Default Value to Participant FormData 
              this.formparticipantData                         = this.formparticipantDataVarible;
              //---------------------------------------------------------------------------------------------
              this.popuptitle                                 = 'Add Participant';
              this.popupparticipantVisible                    = true;
              this.buttondisable                              = true;
              break;  
            }
        //---------------------------------------------------------------------------------------------
        // Edit Participant
        case 20:
          {
            if ( status )
              {
                  this.popuptitle                = 'Edit Participant';
                  this.popupparticipantVisible  = true;
              }

            break;  
          }
        //---------------------------------------------------------------------------------------------
    
      }

    }
  //*******************************************************
  inputchanged( event:any )
    {
      // If Input Value Changes than Changes X Button will be Enable
      this.datachange = false;
    }
  //******************************************************
  valuechanged( event:any, selfield: number )
    {
      // Track Previous and Current Values

      switch ( selfield )
        {
          case 1:
              {
                this.previnvitevalue    = event.previousValue;
                this.currinvitevalue    = event.value;
                console.log( this.previnvitevalue   + ' ' + this.currinvitevalue  )
                break;
              }

          case 10:
            {
              this.prevbudgetvalue      = event.previousValue;
              this.currbudgetvalue      = event.value;
              console.log( this.prevbudgetvalue    + ' ' +this.currbudgetvalue     )
              break;
            }

        }
   
    }
  //******************************************************
  infoclick(event: any, whatcard: number, whatinfo: number)
      {
        // Hannah
        var incdecchange: number;
        //---------------------------------------------------------------------------------------------
        switch ( whatcard )
          {
            //---------------------------------------------------------------------------------------------
            case 1:  // Event Guest No
              {   
                //---------------------------------------------------------------------------------------------
                this.datachange = true;   // Disable Undo Button
                //---------------------------------------------------------------------------------------------
                switch ( whatinfo )
                  {
                    //---------------------------------------------------------------------------------------------
                    case 0:
                        {
                          let result = this.validationGuestNo.instance.validate();
                        
                          if (result.isValid) 
                            {
                                //---------------------------------------------------------------------------------------------
                                // Save Input Data
                                this.firestoredata.commitbatchupdate( this.pathorganiserprofile, 
                                                                      this.eventid,
                                                                      this.selorgid,
                                                                      'noguestinvite', 
                                                                      this.selnoguestinvite); 
                                //---------------------------------------------------------------------------------------------
                                // Save Statistic Budget
                                incdecchange = this.selnoguestinvite - this.previnvitevalue;

                                this.firestoredata.commitIncDecbatchupdate( this.pathstatTotalinviteeprofile, 
                                                                            this.eventid,
                                                                            this.selorgid,
                                                                            'totalcoming', 
                                                                            incdecchange); 
                              
                                this.firestoredata.commitIncDecbatchupdate( this.pathstatTotalinviteeprofile, 
                                                                            this.eventid,
                                                                            'total',
                                                                            'totalcoming', 
                                                                            incdecchange); 
                                //---------------------------------------------------------------------------------------------
                                this.prevselnoguestinvite = this.selnoguestinvite;
                                
                            }
                          else
                            {
                              this.datachange = false;              // Enable Undo Button
                            }

                          break;
                        }

                    // Event Guest No
                    case 1:
                      {
                        this.selnoguestinvite   = this.prevselnoguestinvite   // Reset Input Value to the Original Value
                        break;  
                      }
                      
                  }
                //---------------------------------------------------------------------------------------------  
                break;
              }
            //---------------------------------------------------------------------------------------------
            case 10: // Budget 
              {
                //---------------------------------------------------------------------------------------------
                this.datachange = true;  // Hide Undo Button
                //---------------------------------------------------------------------------------------------
                switch ( whatinfo )
                  {
                      
                    case 0:
                        {
                          let result = this.validationBudget.instance.validate();
                        
                          if (result.isValid)
                            {
                                // Save Input Data
                                this.firestoredata.commitbatchupdate( this.pathorganiserprofile, 
                                                                      this.eventid,
                                                                      this.selorgid,
                                                                      'budgetamount', 
                                                                      this.selbudgetamount); 

                                incdecchange = this.selbudgetamount - this.prevbudgetvalue;
                                console.log(  this.prevbudgetvalue + ' ' + this.selbudgetamount )   

                                this.firestoredata.commitIncDecbatchupdate( this.pathstatTotalbudgetprofile, 
                                                                            this.eventid,
                                                                            this.selorgid,
                                                                            'totalbudget', 
                                                                            incdecchange); 
                                                                    
                                this.firestoredata.commitIncDecbatchupdate( this.pathstatTotalbudgetprofile, 
                                                                            this.eventid,
                                                                            'total',
                                                                            'totalbudget', 
                                                                            incdecchange); 
                                  
                                this.prevselbudgetamount= this.selbudgetamount;
                            }
                          else
                            {
                              this.datachange = false;              // Enable Undo Button
                            }

                          break;
                        }

                  
                    case 1:
                        {
                          this.selbudgetamount = this.prevselbudgetamount   // Reset Input Value to the Original Value
                          break;  
                        }
                  }
                //---------------------------------------------------------------------------------------------  

                break;  
              }
            //---------------------------------------------------------------------------------------------
            case 20:  // Event Type
              {
                //---------------------------------------------------------------------------------------------
                this.datachange = true;  // Hide Undo Button
                //---------------------------------------------------------------------------------------------
                switch ( whatinfo )
                  {
                     
                    // Save Btn 
                    case 0:
                        {
                          let result = this.validationEventName.instance.validate();
                        
                          if (result.isValid) 
                            {
                            //  console.log( this.pathcommonprofile + ' ' +   this.eventid)
                              // Save Input Data
                              this.firestoredata.commitbatchupdate( this.pathcommonprofile, 
                                                                    this.eventid,
                                                                    '100',
                                                                    'eventtype', 
                                                                    this.seleventtype); 

                                this.prevseleventtype  = this.seleventtype;
                                
                            }
                          else
                            {
                              this.datachange = false;              // Enable Undo Button
                            }

                          break;
                        }

                     // Undo Btn
                     case 1:
                      {
                        this.seleventtype = this.prevseleventtype   // Reset Input Value to the Original Value  // Reset Input Value to the Original Value
                        break;
                      }

                  }

                break;

              }
            //---------------------------------------------------------------------------------------------
            case 30:  // Event Location
              {
                //---------------------------------------------------------------------------------------------
                this.datachange = true;  // Hide Undo Button
                //---------------------------------------------------------------------------------------------
                switch ( whatinfo )
                  {
                    
                    // Save Btn 
                    case 0:
                        {
                          let result = this.validationEventLocation.instance.validate();
                        
                          if (result.isValid) 
                            {
                  
                              // Save Input Data
                              this.firestoredata.commitbatchupdate( this.pathcommonprofile, 
                                                                   this.eventid,
                                                                   '100',
                                                                    'eventlocation', 
                                                                    this.seleventlocation); 

                              this.prevseleventlocation  = this.seleventlocation
                                
                            }
                          else
                            {
                              this.datachange = false;              // Enable Undo Button
                            }

                          break;
                        }

                    // Undo Btn
                    case 1:
                      {
                        this.seleventlocation = this.prevseleventlocation   // Reset Input Value to the Original Value  // Reset Input Value to the Original Value
                        break;
                      }

                  }

                break;

              }
            //---------------------------------------------------------------------------------------------
            case 40:  // Event Date
              {
                //---------------------------------------------------------------------------------------------
                this.datachange = true;  // Hide Undo Button
                //---------------------------------------------------------------------------------------------
                switch ( whatinfo )
                  {
                    
                    // Save Btn 
                    case 0:
                        {
                          let result = this.validationEventDate.instance.validate();
                        
                          if (result.isValid) 
                            {
                              //---------------------------------------------------------------------------------------------
                              // Save Rsvp Date
                              this.firestoredata.commitbatchupdate( this.pathcommonprofile, 
                                                                    this.eventid,
                                                                    '100',
                                                                    'eventrsvpdate', 
                                                                    this.seleventrsvpdate); 

                              this.prevseleventrsvpdate  = this.seleventrsvpdate;
                              //---------------------------------------------------------------------------------------------
                              // Save Event Date
                              this.firestoredata.commitbatchupdate( this.pathcommonprofile, 
                                                                   this.eventid,
                                                                  '100',
                                                                  'eventdate', 
                                                                  this.seleventdate); 

                              this.prevseleventdate  = this.seleventdate;
                              //---------------------------------------------------------------------------------------------  
                            }
                          else
                            {
                              this.datachange = false;              // Enable Undo Button
                            }

                          break;
                        }

                    // Undo Btn
                    case 1:
                      {
                        this.seleventrsvpdate = this.prevseleventrsvpdate;  // Reset Input Value to the Original Value
                        this.seleventdate     = this.prevseleventdate;      // Reset Input Value to the Original Value  
                        break;
                      }

                  }

                break;

              }
            //---------------------------------------------------------------------------------------------
          }
          
      };
    //******************************************************
    statusvisible() 
      {
          return this.datachange;
      }
    //******************************************************
    toggleFlip( selectflip: number) 
      {
        if ( this.rowselect )
          {
          //------------------------------------------------------
          switch ( selectflip )
            { 
              //------------------------------------------------------  
              // Guest Invite Card Card
              case 1:
                  {
                    
                    if ( !( this.inputstatus ) ) // Input Field + Undo Box was clicked
                      {
                        this.inputguestno.instance.focus();    // focus input box
                        // Prevents from card being flip
                        this.flipguest = 'active';
                      }
                    
                    //------------------------------------------------------
                    this.flipbudget         = 'inactive';
                    this.flipevent          = 'inactive';
                    this.flipeventlocation  = 'inactive';
                    this.flipeventdate      = 'inactive';

                    this.datachange         = true;
                    //------------------------------------------------------
                  
                    break
                  }
              //------------------------------------------------------
              // Budget Amount    
              case 10:
                  {

                    if ( !( this.inputstatus ) ) // Input Field + Undo Box was clicked
                      {
                        this.inputbudgetno.instance.focus();    // focus input box
                        // Prevents from card being flip
                        this.flipbudget = 'active';
                      }
                    
                    //------------------------------------------------------
                    this.flipguest          = 'inactive';
                    this.flipevent          = 'inactive';
                    this.flipeventlocation  = 'inactive';
                    this.flipeventdate      = 'inactive';

                    this.datachange         = true;
                    //------------------------------------------------------
                    break
                  }
              //------------------------------------------------------
              // Event Type
              case 20:
                {

                  if ( !( this.inputstatus ) ) // Input Field + Undo Box was clicked
                    {
                      this.inputevent.instance.focus();    // focus input box
                      // Prevents from card being flip
                      this.flipevent = 'active';
                    }
                  //------------------------------------------------------
                  this.flipguest          = 'inactive';
                  this.flipbudget         = 'inactive';
                  this.flipeventlocation  = 'inactive';
                  this.flipeventdate      = 'inactive';

                  this.datachange         = true;
                  //------------------------------------------------------
                  break
                }
              //------------------------------------------------------
              // Event Location
              case 30:
                {
                  
                  if ( !( this.inputstatus ) ) // Input Field + Undo Box was clicked
                    {
                      this.inputeventlocation.instance.focus();    // focus input box
                      // Prevents from card being flip
                      this.flipeventlocation = 'active';
                    }
                
                  //------------------------------------------------------
                  this.flipguest          = 'inactive';
                  this.flipbudget         = 'inactive';
                  this.flipevent          = 'inactive';
                  this.flipeventdate      = 'inactive';

                  this.datachange         = true;
                  //------------------------------------------------------
              
                  break
                }
              //------------------------------------------------------
              // Event Date
              case 40:
                {
                  if ( !( this.inputstatus ) ) // Input Field + Undo Box was clicked
                    {
                      this.inputrsvpeventdate.instance.focus();    // focus input box
                      // Prevents from card being flip
                      this.flipeventdate = 'active';
                    }
                  //------------------------------------------------------
                  this.flipguest          = 'inactive';
                  this.flipbudget         = 'inactive';
                  this.flipevent          = 'inactive';
                  this.flipeventlocation  = 'inactive';

                  this.datachange         = true;
                  //------------------------------------------------------

                  break;
                }
              //------------------------------------------------------
            }

          }
        else
          {
            this.toastFileMessage = 'Please select Event Organiser';
            this.toasttypeerror   = 'error';
            this.toastdisplaytime = 5000;
            this.toastwidth       = '250';
            this.toastVisible     = true;
            this.toastposX        = 180;
            this.toastposY        = 20;
          }

      }
    //******************************************************
    // Triggered when a Participant Row is Selected
    eventprofiles( event: any  )
      {
        //------------------------------------------------------
        if ( !this.rowselect )
          {
            this.rowselect = true; // This will Trigger the FLIP CARDS

            // Establish Connection to event -> eventparticipantcommon
            this.firestoredata.loadeventparticipantcommon( this.eventid );

            this.subscriptioneventparticipantcommon = this.firestoredata.geteventparticipantcommon().subscribe
              ( items => 
                { 
                  this.subscriptioneventparticipantlistcommon = items;
                
                  if ( this.subscriptioneventparticipantlistcommon.length == 0 )
                    {

                      // This will never OCCUR since Common Profiles will created when the EVENT is PAID and REGISTERED
                   //   this.seleventtype             = 'TBC';
                   //   this.seleventlocation         = 'TBC';
                    
                   //  this.seleventdate             =  new Date();   // If no common profiles been set it default to todays data  
                    //  this.seleventdatestring       = 'TBC';

                   //   this.seleventrsvpdate         =  new Date();
                  //    this.seleventrsvpdatestring   = 'TBC'; 

                      // Update Common Profiles 
                  //    this.firestoredata.addUpdateCommonProfile( this.eventid, 
                  //                                              '100',            // default Id
                  //                                              this.seleventtype,
                   //                                             this.seleventlocation,
                  //                                              this.seleventdatestring,
                   //                                             this.seleventrsvpdatestring  ).then( data => {
                   //                                                                                 var successORFail: number;
                   //                                                                                 successORFail = data
                    //                                                                                console.log( successORFail )
//
                     //                                                                             }
                     //                                             )


                    }
                  else
                    {
                    
                      // Will automatically update when there is any changes to common parameters
                      this.seleventtype           = this.subscriptioneventparticipantlistcommon[0].eventtype;
                      this.prevseleventtype       = this.seleventtype;

                      this.seleventlocation       = this.subscriptioneventparticipantlistcommon[0].eventlocation
                      this.prevseleventlocation   = this.seleventlocation
                      //------------------------------------------------------
                      // Event Date
                      this.seleventdatestring   = this.subscriptioneventparticipantlistcommon[0].eventdatestring;

                      if (  this.seleventdatestring == 'TBC' ) // TBC = Event Date has not been set.
                        {
                          // If Event Date is not set, Event Date will be set to current date
                          this.seleventdate = new Date();
                        }
                      else
                        { 
                          // Set the Date to event date
                          let selseconds = this.subscriptioneventparticipantlistcommon[0].eventdate['seconds'];
                          let nonoseconds = this.subscriptioneventparticipantlistcommon[0].eventdate['nonoseconds'];
                          
                          this.seleventdate  = this.appfunction.convert_firestoretimestamp_to_data( 
                                                                                                    selseconds,
                                                                                                    nonoseconds
                                                                                                  )
                        }

                      this.prevseleventdate   = this.seleventdate
                      //------------------------------------------------------
                      // RSVP date
                      this.seleventrsvpdatestring  = this.subscriptioneventparticipantlistcommon[0].eventrsvpdatestring

                      if (  this.seleventrsvpdatestring == 'TBC' ) // TBC = Event Date has not been set.
                        {
                          // If Event Date is not set, Event Date will be set to current date
                          this.seleventrsvpdate = new Date();
                        }
                      else
                        { 
                          // Set the Date to event date
                          let selseconds = this.subscriptioneventparticipantlistcommon[0].eventrsvpdate['seconds'];
                          let nonoseconds = this.subscriptioneventparticipantlistcommon[0].eventrsvpdate['nonoseconds'];
                          
                          this.seleventrsvpdate  = this.appfunction.convert_firestoretimestamp_to_data( 
                                                                                                    selseconds,
                                                                                                    nonoseconds
                                                                                                  )
                        }

                      this.prevseleventrsvpdate  = this.seleventrsvpdate
                      //------------------------------------------------------    

                    }
                
                }
              )

          }
        //------------------------------------------------------
      }
    //******************************************************
    setcardcommentary( whatcard: number )
      {
        switch ( whatcard )
          {
            //------------------------------------------------------
            // Guest Invite
            case 1: {
                      if ( this.selnoguestinvite == 0 )
                        {
                          return "How many Guest/Friends are you inviting" + "<br/>" + " Flip to Update";
                        }
                      else
                        {
                      
                          this.fliptext = "You have invited " + "XXX" + " Guest/Friends";
                          this.fliptext = this.fliptext.replace(/XXX/g, '<span class="font19black">'  + this.selnoguestinvite.toString() + '</span>' )
                          
                          return this.fliptext
                       
                        } 
                     
                    }

            //------------------------------------------------------
            // Budget Amount
            case 10: {
                        
                        if ( this.selbudgetamount == 0 )
                          {
                            return  "What is your budget" + "<br/>" + " Flip to Update";
                          }
                        else
                          {
                            this.fliptext = "You have set a budget of "  + "XXX"
                            this.fliptext = this.fliptext.replace(/XXX/g,'<span class="font19black">' + this.selbudgetamount.toString() + '</span>' )
                            return this.fliptext;
                          }

                      }
            //------------------------------------------------------          
            // Event what type
            case 20: {
                        
                        if ( this.seleventtype == "TBC" )
                          {
                            return  "What is your event " + "<br/>" + " Flip to Update";
                          }
                        else
                          {
                            
                            this.fliptext = "Your event is a "  + "XXX"
                            this.fliptext = this.fliptext.replace(/XXX/g,'<span class="font19black">' + this.seleventtype + '</span>' )
                            return this.fliptext;
                          }
                       
                      }
            //------------------------------------------------------  
            // Event Location
             case 30: {
                        
                        if ( this.seleventlocation == 'TBC' )
                          {
                            return "Where is your event held" + "<br/>" + " Flip to Update";
                          }
                        else
                          {
                            this.fliptext = "Event location is "  + "XXX" 
                            this.fliptext = this.fliptext.replace(/XXX/g,'<span class="font19black"">' + this.seleventlocation + '</span>' )
                            return this.fliptext;
                          }
                        
                      }
            //------------------------------------------------------          
            // Event Date
            case 40: {
                        
                        if ( this.seleventdatestring == 'TBC' )
                          {
                            return "What is the Rsvp and Event date" + "<br/>" + " Flip to Update";
                          }
                        else
                          {
                            this.fliptext = "Rsvp Date is " + "XXX" + " .Event Date is "  + "YYY" 
                            this.fliptext = this.fliptext.replace(/XXX/g,'<span class="font19black"">' + formatDate( this.seleventrsvpdate, 'dd-MM-yyyy' ,this.locale)  + '</span>' )
                            this.fliptext = this.fliptext.replace(/YYY/g,'<span class="font19black"">' + formatDate( this.seleventdate, 'dd-MM-yyyy' ,this.locale)  + '</span>' )
                            return this.fliptext;
                          }
                        
                      }

          }

          return "XXXXX"
      }
    //******************************************************
    onrowchange( event: any )
      {
        //console.log( event.row.data)
        this.dataGrid.instance.clearSelection();

        // Organiser Id
        this.selorgid           = event.row.data.id;

        // Set Flip Cards 
        this.flipguest          = 'inactive';
        this.flipbudget         = 'inactive';
        this.flipevent          = 'inactive';
        this.flipeventlocation  = 'inactive';
        this.flipeventdate      = 'inactive';
        //------------------------------------------------------
        // No of guest Invited for Organiser
        this.selnoguestinvite       = event.row.data.noguestinvite;
        this.prevselnoguestinvite   = this.selnoguestinvite
        //------------------------------------------------------
        // Budget Amount for Organiser
        this.selbudgetamount        = event.row.data.budgetamount;
        this.prevselbudgetamount    = this.selbudgetamount;
        //------------------------------------------------------
        // Event Type i.e. wedding
        this.seleventtype           = this.seleventtype
        this.prevseleventtype       = this.seleventtype;
        //------------------------------------------------------
        // Event Location i.e. address
        this.seleventlocation       = this.seleventlocation;
        this.prevseleventlocation   = this.seleventlocation;
        //------------------------------------------------------
        // Event Date
        this.seleventdate       = this.seleventdate;
        this.prevseleventdate   = this.seleventdate;
        //------------------------------------------------------
      }
    //******************************************************
    inputonclickstatus( event: any, whatstatus: boolean )
      {
        // true   = focus is input box
        // false  = focus is not in input box
        this.inputstatus = whatstatus;
      }
    //******************************************************
    validatenumberinput(e): boolean
      {
        return ( e.value != 0 )
      }
    //******************************************************
    validatetextinput(e): boolean
      {
        var textinput: string

        textinput = e.value;
        return ( textinput.length != 0 )
      }
    //******************************************************
    validatedateinput(e): boolean
      {
        //return ( e.value != 0 )
        return false;
      }
    //******************************************************
    // Temporary Format 
    locale_setdatecurrencytime( sellocaleId: string )
      {
        switch ( sellocaleId )
          {
            case 'en-AU':
              {
                this.localedateformat = "d/MM/yyyy"
                break;
              }

          }

         // for = getLocaleDateFormat('en-GB',     
         // FormatWidth.Short);

      }
    //******************************************************
    // Fires on button click
    onBtnClick()
      {
          // Send a notification to the parent 
          // that the button is clicked inside the child component
          console.log( 'Emit')
          this.childEmitter.emit();
      }

    errorstatus(event: any)
      {
        console.log('ssssss')

       
        var items = event.component.option('items');  
       console.log( items.length )


      }


    onClick(e){
      alert("Test");
          //this.dataGrid.instance.saveEditData();
      }




    
  }
//**************************************************************